import type { ModalConfig } from "./types";

export const adminUserModalsModalUrlConfig = {
  // Admin User Modals
  //
  // `entityName` must be the string `/admin/users` passes to
  // `UniversalEntityPage` ("admin_users"), because the row-click handler builds
  // its modal id as `${entityName}-detail`.
  "admin_users-detail": {
    modalId: "admin_users-detail",
    entityName: "admin_users",
    singularParam: "adminUserId",
    pluralParam: "adminUsersId",
    displayName: "User",
  },
} as const satisfies Record<string, ModalConfig>;
